import type { ProductRoot } from '@/components/ProductFullDetail-new/types/product';
import useIsMobile from '@/hooks/use-is-mobile';
import { getMediaGalleryEntries } from '@/util/productFullDetailUtil';
import { useMemo } from 'react';
import type { OptionsSelectionsMap } from '../lib/get-optionSelections';
import { useProductFullDetailStore } from '../store/use-product-full-detail-store';

export const useGetMediaGalleryEntries = ({
  product,
  optionSelections,
}: {
  product: ProductRoot;
  optionSelections: OptionsSelectionsMap;
}) => {
  const optionCodes = useProductFullDetailStore(state => state.getOptionCode(product));

  const isMobile = useIsMobile();

  const mediaGalleryEntries = useMemo(
    () => getMediaGalleryEntries(product, optionCodes, optionSelections, isMobile),
    [product, optionCodes, optionSelections, isMobile],
  );

  return {
    mediaGalleryEntries,
  };
};
